import React from "react"


const useAuthUser=(firebase)=>{
  const [authUser,setAuthUser]=React.useState()

  React.useEffect(()=>{
    if(!!firebase){
      console.log("useAuthUser useEffect")
      return firebase.auth.onAuthStateChanged(
        authUserFB => {
          console.log("authUserFB",authUserFB)
          setAuthUser(authUserFB)
        }
        )
    }
  },[firebase])
  
  return authUser
}

export default useAuthUser